import { render, staticRenderFns } from "./jumlahPerkawinan.vue?vue&type=template&id=52c56e68&scoped=true&"
import script from "./jumlahPerkawinan.vue?vue&type=script&lang=js&"
export * from "./jumlahPerkawinan.vue?vue&type=script&lang=js&"
import style0 from "./jumlahPerkawinan.vue?vue&type=style&index=0&id=52c56e68&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52c56e68",
  null
  
)

export default component.exports